(function ($, document, window) {
	'use strict';

	$(function () {
		$('.js-instagram-carousel').each(function () {
			const sliderContainer = $(this);
			const sliderEl = $('.swiper', sliderContainer)[0];

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				spaceBetween: 20,
				slidesPerView: 'auto',
				preventInteractionOnTransition: true,
				centeredSlides: true,
				speed: 20000,
				simulateTouch: false,
				loop: true,

				autoplay: {
					reverseDirection: true,
					delay: 0,
				},

				breakpoints: {
					1280: {
						spaceBetween: 40,
					},

					1772: {
						slidesPerView: 4,
						spaceBetween: 40,
					}
				},

				on: {
					init: function () {
						sliderEl.classList.remove('swiper-uninitialized');
					},

					resize: function () {
						this.autoplay.start();
					},
				},
			});
		});
	});
})(jQuery, document, window);
